/** Purchase UI is opt-in to the fresh, authoritative API contract. */
export interface CommerceCapabilities {
  effective_sale_mode: string;
  effective_price_mode: string;
  can_purchase: boolean;
  show_price: boolean;
  show_stock: boolean;
  revision: string;
}

type Subject = { commerce?: CommerceCapabilities } | null | undefined;

function isSale(subject: Subject): boolean {
  const value = subject?.commerce;
  return !!value && typeof value.revision === "string" && value.revision.trim().length > 0 &&
    value.effective_sale_mode === "purchase" && value.effective_price_mode === "show";
}

export function showsPrice(subject: Subject): boolean {
  return isSale(subject) && subject?.commerce?.show_price === true;
}

export function showsStock(subject: Subject): boolean {
  return isSale(subject) && subject?.commerce?.show_stock === true;
}

export function canPurchase(subject: Subject): boolean {
  return showsPrice(subject) && showsStock(subject) && subject?.commerce?.can_purchase === true;
}
